import { alpha, Box, styled } from "@material-ui/core";
import PropTypes from "prop-types";
import SimpleBarReact from "simplebar-react";
// material

// ----------------------------------------------------------------------

const RootStyle = styled("div")({
  flexGrow: 1,
  height: "100%",
  overflow: "hidden",
  maxHeight: "100%",
});

const SimpleBarStyle = styled(SimpleBarReact)(({ theme }) => ({
  maxHeight: "100%",

  // Barra de scroll vertical
  "& .simplebar-scrollbar": {
    "&:before": {
      backgroundColor: alpha(theme.palette.primary.main, 0.4), // Color principal
      borderRadius: 4, // Bordes redondeados
    },
    "&.simplebar-visible:before": {
      opacity: 1,
    },
  },

  // Track (fondo) de la barra vertical
  "& .simplebar-track.simplebar-vertical": {
    width: 9, // Ancho
    right: 2, // Separación del borde
    backgroundColor: alpha(theme.palette.grey[300], 0.3), // Fondo sutil
    borderRadius: 4,
  },

  // Barra de scroll horizontal
  "& .simplebar-track.simplebar-horizontal": {
    height: 9,
    bottom: 2,
    backgroundColor: alpha(theme.palette.grey[300], 0.3),
    borderRadius: 4,

    "& .simplebar-scrollbar": {
      height: 6,
      "&:before": {
        backgroundColor: alpha(theme.palette.primary.main, 0.4),
        borderRadius: 4,
      },
    },
  },

  // Efecto hover en la barra
  "& .simplebar-scrollbar:before": {
    transition: "background-color 0.2s ease",
  },

  "& .simplebar-track:hover .simplebar-scrollbar:before": {
    backgroundColor: alpha(theme.palette.primary.main, 0.6), // Más visible al hover
  },

  "& .simplebar-mask": {
    zIndex: "inherit",
  },

  // Área de contenido con scroll suave
  "& .simplebar-content-wrapper": {
    scrollBehavior: "smooth",
  },
}));

// ----------------------------------------------------------------------

Scrollbar.propTypes = {
  children: PropTypes.node.isRequired,
  sx: PropTypes.object,
};

export default function Scrollbar({ children, sx, ...other }) {
  const isMobile =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent,
    );

  if (isMobile) {
    return (
      <Box
        sx={{
          overflowX: "auto",
          // Habilita scroll nativo con momentum en iOS Safari
          WebkitOverflowScrolling: "touch",
          // Scroll nativo en móvil también personalizado
          "&::-webkit-scrollbar": {
            width: "6px",
            height: "6px",
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: "transparent",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.4),
            borderRadius: "3px",
            "&:hover": {
              backgroundColor: (theme) =>
                alpha(theme.palette.primary.main, 0.6),
            },
          },
          ...sx,
        }}
        {...other}
      >
        {children}
      </Box>
    );
  }

  return (
    <RootStyle>
      <SimpleBarStyle timeout={500} clickOnTrack={false} sx={sx} {...other}>
        {children}
      </SimpleBarStyle>
    </RootStyle>
  );
}
